import { useQuery } from '@tanstack/react-query';
import { searchApi } from '../api/searchApi';

export const useCodeDetail = (codeType: string, code: string) => {
  return useQuery({
    queryKey: ['codeDetail', codeType, code],
    queryFn: () => searchApi.getCodeDetail(codeType, code),
    enabled: !!codeType && !!code,
  });
};